<template>
  <div>
    <!-- Contenu de la page -->
    <div class="container-fluid">
      <BarreFiltres ref="barreFiltres" :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
      <BarreActions ref="barreActions" :actions="actions" @appliquer-action="executerAction($event)" />

      <ModalImportMercuComplementaire ref="modalImportMercuComplementaire" :listeFournisseurs="listeFournisseurs" :optionsFamilles="optionsFamilles" />
      <ModalAjoutProduitComplementaire ref="modalAjoutProduitComplementaire" :produitComplementaire="produitSelectionne" :paramModale="paramModale" :optionsUC="optionsUC" @produit-modifie="majListeProduit($event)" />

      <div class="card table-scroll height-responsive-0b">
        <div class="card-header flex-center-space-between">
          <div class="flex-start">
            <span>{{ fournisseurSelectionne.nom }}</span>
          </div>
          <span>
            {{ familleSelectionnee.texte }} (Prix affichés en base 100)
          </span>
          <span>
            {{ periodeTarif }} 
          </span>
        </div>
        <table class="table table-bordered table-sm text-center table-header-secondary"> <!-- style="display:block;max-height:800px;overflow:auto" -->
        <!--<table class="table table-bordered text-center">-->
          <colgroup>
            <col width="180">
            <col>
            <col width="180">
            <col width="100">
            <col width="100">
            <col width="80">
            <col width="80">
            <col width="200">
            <col width="50">
          </colgroup>
          <thead>
            <th class="aligner-gauche">Ingrédient</th>
            <th class="aligner-gauche watchMe" @click="trierListe('designation')">Désignation<i v-if="afficheIconeTri('designation')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('marque')">Marque<i v-if="afficheIconeTri('marque')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('reference')">Référence<i v-if="afficheIconeTri('reference')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('prix', true)">P.U.<i v-if="afficheIconeTri('prix')" :class="iconeSensTri"></i></th>
            <th>PCB</th>
            <th>TVA</th>
            <th>Allergènes</th>
          </thead>
        </table>
        <div class="table-body">
          <table class="table table-bordered table-sm text-center">
            <colgroup>
              <col width="180">
              <col>
              <col width="180">
              <col width="100">
              <col width="100">
              <col width="80">
              <col width="80">
              <col width="200">
              <col width="45">
            </colgroup>
            <tbody>
              <tr :class="[{'ligne-selectionnee':produits.produitId === idProduitSelectionne && produits.tarifId === idTarifSelectionne}]" v-for="(produits, iProduit) in produitsComplementaire" :key="iProduit" @click="selectionnerProduit(produits)">
                <template>
                  <td v-if="!produits.ingredient" class="aligner-gauche">
                    <em class="text-warning">Pas d'ingrédient</em>
                  </td>
                  <td v-else class="aligner-gauche"> 
                    {{ produits.ingredient }}
                  </td>
                  <td class="aligner-gauche">{{ produits.designation }}</td>
                  <td>{{ produits.marque }}</td>
                  <td>{{ produits.reference }}</td>
                  <td>{{ produits.prixUnitaireHT }} €</td>
                  <td>{{ produits.pcb }} {{ produits.uc }}</td>
                  <td>{{ produits.tauxTVA }} </td>
                  <td>
                    {{ formatAllergene(produits) }}
                    <em v-if="sansAllergene(produits)" class="error ml-2">
                      <i class="fas fa-exclamation-triangle ligne-modifiee"></i> Aucun allergène sélectionné
                    </em>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarreFiltres from '@/components/Divers/BarreFiltres'
import BarreActions from '@/components/Divers/BarreActions'
import { connecteData } from "@/mixins/connecteData"
import { showAlerts } from "@/mixins/alerts"
import { formatageDate, formatHumanDateAvecSlashes } from '@/mixins/dateFormats'
import { obtenirProduitsComplementaires, /*exporterProduitsComplementaires,*/ supprimerUnProduitComplementaire } from '@/api/gpao/mercuriales'
import { chargerFournisseursStandardEtSpeciaux } from '@/api/gpao/fournisseurs'
import { /*lancerTelechargementDeResponse,*/ Nombre } from "@/helpers/utils"
import ModalImportMercuComplementaire from '@/components/Divers/ModalImportMercuComplementaire'
import ModalAjoutProduitComplementaire from '@/components/Divers/ModalAjoutProduitComplementaire'
import { mapGetters } from "vuex"
import _ from 'lodash'

export default {
  name: "PageDetailMercurialeComplementaire",
  components: {
    BarreFiltres,
    BarreActions,
    ModalImportMercuComplementaire,
    ModalAjoutProduitComplementaire
  },
  mixins: [connecteData, showAlerts, formatageDate, formatHumanDateAvecSlashes],
  data() {
    return {
      triAsc: null,
      colonneTriee: "",
      idFamilleSelectionnee: null,
      idFournisseurSelectionnee: null,
      dateDebutTarifSelectionnee: null,
      dateDebutTarifSelectionneeFormat: null,
      familleSelectionnee: {},
      fournisseurSelectionne: {},
      listeFournisseurs : [], //tous les fournisseurs
      produitsComplementaire: [],
      produitsComplementaireInitial: [],
      optionsFamilles: [], //Toutes les familles au format combo
      optionsFournisseurs: [],
      optionsUC: [],
      filtreProduits: '',
      idProduitSelectionne: "",
      idTarifSelectionne: "",
      enExportation: false,
      paramModale: {},

      isLoading: false,
      filtres: {
        nomproduit : {
          label: "Recherche un produit",
          champ: "input",
          type: "text",
          selection: "",
          initialiser(contexte) {
            contexte.filtres.nomproduit.selection = contexte.filtreProduits
          },
          filtrer(contexte) {
            contexte.filtreProduits = contexte.filtres.nomproduit.selection
            contexte.filtrer()
          }
        },
        // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          //contexte.reinitialiser()
          //Pas de filtre pour le moment
          contexte.filtres.barreGauche = [ ]
          contexte.filtres.barreDroite = [ ] 
          contexte.filtres.barreGauche.forEach(f => {
            if (f.initialiser) {
              f.initialiser(contexte)
            }
          })
        },
        filtrer(contexte, commande) {
          return !contexte.filtres.barreFiltres.find(f => !f.filtrer(contexte, commande))
        }
      },
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        // exporter: {
        //   label: "Exporter",
        //   methode(contexte) {
        //     contexte.exporterProduits()  
        //   }
        // },
        importer: {
          label: "Importer",
          disabled: false,
          methode(contexte) {
            contexte.importerProduits()
          }
        },
        modifier: {
          label: "Modifier",
          disabled: true,
          methode(contexte) {
            contexte.modifierDetailProduit()
          }
        },
        ajouter: {
          label: "Ajouter",
          methode(contexte) {
            contexte.ajouterProduit()
          }
        },
        supprimer: {
          label: "Supprimer",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            let cmd = contexte.produitSelectionne
            if (cmd) {
              contexte.supprimeProduit(cmd)
            }
          }
        },
        retour: {
          label: "Retour",
          methode(contexte) {
            contexte.$router.push({ name: "ConfigurationMercuComplementaire" })
          }
        },
        
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ /*contexte.actions.exporter, contexte.actions.importer,*/ contexte.actions.ajouter ]
          contexte.actions.barreDroite = [ contexte.actions.retour, contexte.actions.modifier, contexte.actions.supprimer ]
          contexte.actions.disableAjouter(contexte.actions, !contexte.mercurialeModifiable)
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.modifier ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        disableAjouter(actions, disabled) {
          let actionsATraiter = [ actions.ajouter ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        disableSupprimer(actions, disabled) {
          let actionsATraiter = [ actions.supprimer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        /*disableEnregistrer(actions, disabled) {
          let actionsATraiter = [ actions.enregistrer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }*/
      }
    }
  },
  computed: {
    ...mapGetters("definitions", ["familles"]),
    produitSelectionne() {
      return this.produitsComplementaire?.find(c => c.produitId === this.idProduitSelectionne && c.tarifId === this.idTarifSelectionne) ?? {}
    }, 
    mercurialeModifiable() {
      return this.dateDebutTarifSelectionnee > this.formatDatePourApiSansSeparation(new Date())
    },
    periodeTarif() {
      return (this.dateFinTarifSelectionneeFormat ? 'du ' : '') + this.dateDebutTarifSelectionneeFormat + (this.dateFinTarifSelectionneeFormat ? (' au ' + this.dateFinTarifSelectionneeFormat) : '')
    }
  },
  methods: {
    appliquerFiltre(filtrer) {
      // Nécessaire pour faire fonctionner les filtres de la barre de filtres
      filtrer(this)
    },
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'action
      methode(this)
    },
    afficheIconeTri(col) {
      return this.triAsc != null && this.colonneTriee == col
    },
    trierListe(nomColonne, triNumerique) {
      let sens = this.triAsc ?? true //visiblement dans le sort, this.triAsc n'est pas connu, donc on copie dans une variable locale
      this.produitsComplementaire.sort(function(a, b) {
        let i = sens ? (triNumerique ? a[nomColonne] || 0 : a[nomColonne]?.toLowerCase() || '')  : (triNumerique ? b[nomColonne] || 0 : b[nomColonne]?.toLowerCase() || '')
        let j = sens ? (triNumerique ? b[nomColonne] || 0 : b[nomColonne]?.toLowerCase() || '') : (triNumerique ? a[nomColonne] || 0 : a[nomColonne]?.toLowerCase() || '')

        //Pour que ça fonctionne aussi bien en numérique que Texte, on fait les tests
        if (i < j)
          return -1
        
        if (i > j)
          return 1
        
        return 0
      })

      //changement du sens du tri
      this.triAsc = !sens
      this.colonneTriee = nomColonne
    },
    obtenirDate(dt) {
      //reconstruit une date au format AAAAMMJJ en objet date
      let year  = dt.substring(0, 4);
      let month = dt.substring(4, 6); // attention : 0 = janvier
      let day   = dt.substring(6, 8);

      return new Date(year, month - 1, day)
    },
    async chargerDetailMercuriale(famId, fourId, dtDebutTarif, dtFinTarif) {
      this.isLoading = true
      this.$store.commit('uxHelpers/showSpinner')

      this.familleSelectionnee = this.optionsFamilles.filter(f => f.valeur === famId).first() ?? {}
      this.fournisseurSelectionne = this.listeFournisseurs.filter(f => f.id === fourId).first() ?? {}
      
      this.dateDebutTarifSelectionneeFormat = this.formatHumanDateAvecSlashes(this.obtenirDate(dtDebutTarif))
      
      if (dtFinTarif >= '20991231')
        this.dateFinTarifSelectionneeFormat = null
      else
        this.dateFinTarifSelectionneeFormat = this.formatHumanDateAvecSlashes(this.obtenirDate(dtFinTarif))

      let response = await obtenirProduitsComplementaires(fourId, famId, dtDebutTarif)
      if (!response) {
        this.$store.commit('uxHelpers/hideSpinner')
        this.isLoading = false
        return
      }
      this.$store.commit('uxHelpers/hideSpinner')

      this.produitsComplementaire = response.data
      this.produitsComplementaireInitial = _.cloneDeep(response.data)
      
      this.optionsUC = this.construireOptionsUC()
      
      this.isLoading = false
    },
    async majListeProduit() {
      await this.chargerDetailMercuriale(this.idFamilleSelectionnee, this.idFournisseurSelectionnee, this.dateDebutTarifSelectionnee, this.dateFinTarifSelectionnee)
    },
    /*selectFamilleDeProduit(event) {
      this.optionsFournisseurs = this.construireListeFournisseur(event.valeur, null)
      if (!this.optionsFournisseurs.find(o => o.id === this.filtreFournisseurs.valeur)) {
        this.filtreFournisseurs = null
      }
      if (this.optionsFournisseurs?.length === 1) {
        this.filtreFournisseurs = this.optionsFournisseurs[0]
      }
      this.filtres.fournisseurs.initialiser(this)
    },*/
    async obtenirListeFamilles() {
      this.optionsFamilles = this.familles.map((t) => {
        let rObj = {}
        rObj.valeur = t.id
        rObj.texte = t.nom
        return rObj
      });
    },
    async obtenirListeFournisseurs() {
      let reponse = await chargerFournisseursStandardEtSpeciaux()
      this.listeFournisseurs = reponse.data
      this.optionsFournisseurs = this.construireOptionsFournisseur()
    },
    construireOptionsFournisseur() {
      let liste = []

      liste = this.listeFournisseurs.map((t) => {
        let rObj = {}
        rObj.valeur = t.id
        rObj.texte = t.nom
        return rObj
      })

      return liste
    },
    construireOptionsUC() {
      let liste = []
      
      //liste des UC distinct des produits
      liste = this.produitsComplementaire.map((p) => {
        let rObj = {}
        rObj.id = p.uc
        rObj.nom = p.uc
        return rObj
      })

      //On supprime les doublons
      let tmp = liste.filter((a, i) => liste.findIndex((s) => a.id === s.id) === i)

      //On ajoute la liste des UC par défaut
      let listedef = []
      listedef.push({id: "Kg", nom: "Kg"})
      listedef.push({id: "Litre", nom: "Litre"})
      listedef.push({id: "Carton", nom: "Carton"})
      listedef.push({id: "Unité", nom: "Unité"})
      listedef.push({id: "Pièce", nom: "Pièce"})
      listedef.push({id: "Seau", nom: "Seau"})

      //on concatene les UC des produits avec les defauts, et on supprime les doublons
      let toutesUC = [...new Map([...tmp, ...listedef].map(item => [item.id, item])).values()]

      return toutesUC
    },
    selectionnerProduit(produit) {
      if (produit.produitId === this.idProduitSelectionne && produit.tarifId === this.idTarifSelectionne) {
        // La ligne est déjà sélectionnée, on l'ouvre
        this.modifierDetailProduit()
        return
      }
      this.idProduitSelectionne = produit.produitId
      this.idTarifSelectionne = produit.tarifId
      this.produitSelectionneSave = produit
      this.actions.disable(this.actions, !this.produitSelectionne)
      //On peut supprimer un produit/tarif uniquement s'il commence dans le futur !
      this.actions.disableSupprimer(this.actions, (!this.produitSelectionne || !this.mercurialeModifiable))
    },
    modifierDetailProduit() {
      this.paramModale.modeAffichage = "modifierProduit"
      this.$refs.modalAjoutProduitComplementaire.show(this.optionsFamilles, this.optionsFournisseurs, this.idFamilleSelectionnee, this.idFournisseurSelectionnee, this.dateDebutTarifSelectionnee, this.dateFinTarifSelectionnee)
    },
    ajouterProduit() {
      this.paramModale.modeAffichage = "ajoutProduit"
      this.$refs.modalAjoutProduitComplementaire.show(this.optionsFamilles, this.optionsFournisseurs, this.idFamilleSelectionnee, this.idFournisseurSelectionnee, this.dateDebutTarifSelectionnee, this.dateFinTarifSelectionnee)
    },
    sansAllergene(tarif) {
      return (!tarif.aucunAllergene && tarif.allergenesMajeurs && tarif.allergenesMajeurs.length === 0) || !tarif.allergenesMajeurs
    },
    formatAllergene(tarif) {
      if (this.sansAllergene(tarif))
        return ""
      else
        return tarif.aucunAllergene && tarif.allergenesMajeurs.length === 0 ? "Aucun" : tarif.allergenesMajeurs.join(", ")
    },
    // async exporterProduits() {
    //   try {
    //     this.enExportation = true
    //     const response = await exporterProduitsComplementaires(this.idFournisseurSelectionnee, this.idFamilleSelectionnee, this.dateDebutTarifSelectionnee)
    //     lancerTelechargementDeResponse(response)
    //   } finally {
    //     this.enExportation = false
    //   }
    // },
    importerProduits() {
      this.$refs.modalImportMercuComplementaire.show(this.idFamilleSelectionnee, this.idFournisseurSelectionnee)
    },
    async supprimeProduit(prd) {
      try
      {
        
        let ok = await this.alerteConfirmation("Supprimer le produit complémentaire", "Etes-vous certain de vouloir supprimer le produit " + prd.designation + " de la famille " + prd.nomFamille + " du fournisseur " + this.fournisseurSelectionne.nom + " pour le " + this.formatHumanDateAvecSlashes(prd.dateDebut) + " ?");
        if (ok) {
          await supprimerUnProduitComplementaire(prd)
          this.alerteSucces("Produit supprimé !")
          await this.chargerDetailMercuriale(this.idFamilleSelectionnee, this.idFournisseurSelectionnee, this.dateDebutTarifSelectionnee, this.dateFinTarifSelectionnee)
        }
        
      }
      catch
      {
        this.alerteErreur("Erreur lors de la suppression du produit")
      }
      
    }
  },
  async mounted() {
    this.idFamilleSelectionnee = Nombre(this.$route.params.familleId.toString())          // Nécessaire pour fonctionner sur rafraichissement de navigateur
    this.idFournisseurSelectionnee = Nombre(this.$route.params.fournisseurId.toString())  // Nécessaire pour fonctionner sur rafraichissement de navigateur
    this.dateDebutTarifSelectionnee = this.$route.params.dateDebutTarif                   // Au format AAAAMMJJ
    this.dateFinTarifSelectionnee = this.$route.params.dateFinTarif                       // Au format AAAAMMJJ

    await this.obtenirListeFamilles()
    await this.obtenirListeFournisseurs()

    await this.chargerDetailMercuriale(this.idFamilleSelectionnee, this.idFournisseurSelectionnee, this.dateDebutTarifSelectionnee, this.dateFinTarifSelectionnee)
    
    this.filtres.initialiser(this)
    this.actions.initialiser(this)
  },
}
</script>

<style>

</style>
